export default "__VITE_ASSET__4a795607__"